@use "sass:string";
@use "../../styles/breakpoint.module.scss" as *;

$circle-size: 120;
$mobile-visible-images: 3;
$mobile-visible-children: $mobile-visible-images * 2;

.root {
    composes: container from "../../styles/composable/layout.module.css";
    display: flex;
    justify-content: center;
    align-items: center;
    margin-block: 0;

    @media ($below-mobile) {
        > :nth-child(n + #{$mobile-visible-children + 1}):not(.plusCircle) {
            display: none;
        }
    }
}

.circle {
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 1;
    border: 1px solid var(--gray-300);
    border-radius: var(--border-radius-full);
    overflow: hidden;

    @media ($above-mobile) {
        flex: 0 0.5 var(--spacer-#{$circle-size});
    }

    @media ($above-tablet) {
        flex-shrink: 0;
    }

    @media ($below-mobile) {
        width: calc(25% - calc(var(--labui-grid-gap) / 3));
    }
}

.spacer {
    flex: 0 1 var(--spacer-56);
    min-width: var(--labui-grid-gap);
    height: 1px;
    background: var(--gray-300);

    @media ($below-mobile) {
        flex: 0 0 var(--labui-grid-gap);
    }
}

.image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.plusCircle {
    composes: circle;
    border: 1px solid var(--color-contrast);
}

.plusIcon {
    width: var(--spacer-24);
    height: var(--spacer-24);
    fill: var(--color-contrast);
}

:export {
    sizes: string.unquote(
        "(max-width: #{$mobile - 1}) 25vw, #{$circle-size}px"
    );
}
